export function formatCeremonyDate(
  timestampSeconds: number,
  locale: string = 'en-US',
): string {
  let date = new Date(timestampSeconds * 1000);

  return date.toLocaleString(locale, {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    timeZoneName: 'short',
  });
}
